<template>
    <div class="headerbg flex-all-center">
      <div class="headerlayout">
        <div class="header-textlayout">
          <p class="header-text1">{{ $t("home.title1")}}</p>
          <p class="header-text2">{{ $t("home.title2")}}</p>
        </div>
        <p class="header-text3">{{ $t("home.title3")}}</p>
      </div>
    </div>
</template>

<script>
export default {
  name: "HomeHeader",
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style>
.headerbg {
  width: 100%;
  height: 400px;
  background: #000;
}
.headerlayout {
  width: 90%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-family: "OPPO-L";
}
.header-textlayout
{
  max-width: 292px;
  width: 100%;

}
.header-text1
{
  font-size: 42px;
  color: #fff;
   text-align: left;
}

.header-text2 {
  font-size: 42px;
  color: #fff;
  margin-top: 30px;
  text-align: right;
}

.header-text3
{
  max-width: 540px;
  width: 100%;
  font-size: 18px;
  color: #fff;
  text-align: center;
  margin-left: 174px;
}

@media (max-width: 768px) {
  .headerbg {
    width: 100%;
    height: 350px;
    background: #000;
  }
  .headerlayout {
    width: 90%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    font-family: "OPPO-L";
  }

  .header-text1 {
    font-size: 50px;
    color: #fff;
    text-align: left;
    font-weight: bold;
  }

  .header-text2 {
    font-size: 50px;
    color: #fff;
    text-align: left;
    margin-top: 0px;
    margin-left: 0px;
    font-weight: bold;
  }

  .header-text3 {
    font-size: 18px;
    color: #fff;
    text-align: left;
    margin-left: 0px;
    margin-top: 60px;
    margin-bottom: 60px;
  }
}
</style>
